import FormText from 'components/form/FormText';
import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import type { SettingCompanyFormStateType } from '../hooks/useSettingCompany';

import type { JSX } from 'react';

type Props = {
  register: UseFormRegister<SettingCompanyFormStateType>;
  errors: FieldErrors<SettingCompanyFormStateType>;
  isAdmin: boolean;
};

/**
 * カンパニー設定 - 連携セクション
 */
export default function IntegrationSection({ register, errors, isAdmin }: Props): JSX.Element {
  return (
    <div className="form-group">
      <h3 className="title-section title-md fw-bold">連携</h3>
      <div className="row form-row flex-md-row justify-content-between">
        <div className="column col-lg-6 col-xl-6 col-left">
          <FormText
            subject="Benchmark API KEY"
            name="apiKeyBenchmark"
            placeholder="APIキー"
            register={register}
            errors={errors}
            maxLength={100}
            requiredMark={true}
            readOnly={!isAdmin}
          />
          <p className="mt-1">Benchmarkとの連携ができます</p>
        </div>
        <div className="column col-lg-6 col-xl-6 col-right">
          <FormText
            subject="Google Analytics ID"
            name="apiKeyGoogleAnalytics"
            placeholder="UA-XXXXX-Y"
            register={register}
            errors={errors}
            maxLength={100}
            requiredMark={true}
            readOnly={!isAdmin}
          />
          <p className="mt-1">Google Analyticsとの連携ができます</p>
        </div>
      </div>
    </div>
  );
}
